import Color from 'color';
import { convertToDarkRgba } from "../../theme/src";
import { SUPPORTED_ICONS } from './SocialButton';
export const getSocialButtonsTheme = (theme) => ({
    [SUPPORTED_ICONS.blackberry.key]: {
        background: '#000000',
        hover: {
            background: convertToDarkRgba(Color('#000000')),
        },
    },
    [SUPPORTED_ICONS.facebook.key]: {
        background: '#1877f2',
        hover: {
            background: convertToDarkRgba(Color('#1877f2')),
        },
    },
    [SUPPORTED_ICONS.globe.key]: {
        background: theme.colors.primary,
        hover: {
            background: convertToDarkRgba(Color(theme.colors.primary)),
        },
    },
    [SUPPORTED_ICONS.linkedin.key]: {
        background: '#2967b2',
        hover: {
            background: convertToDarkRgba(Color('#2967b2')),
        },
    },
    [SUPPORTED_ICONS.pinterest.key]: {
        background: '#e60023',
        hover: {
            background: convertToDarkRgba(Color('#e60023')),
        },
    },
    [SUPPORTED_ICONS.skype.key]: {
        background: '#0078D7',
        hover: {
            background: convertToDarkRgba(Color('#0078D7')),
        },
    },
    [SUPPORTED_ICONS.twitter.key]: {
        background: '#000000',
        hover: {
            background: convertToDarkRgba(Color('#000000')),
        },
    },
    [SUPPORTED_ICONS.viadeo.key]: {
        background: '#ee7356',
        hover: {
            background: convertToDarkRgba(Color('#ee7356')),
        },
    },
    [SUPPORTED_ICONS.xing.key]: {
        background: '#005a5f',
        hover: {
            background: convertToDarkRgba(Color('#005a5f')),
        },
    },
    default: {
        background: '#fff',
        hover: {
            background: '#f5f5f5',
        },
    },
});
//# sourceMappingURL=utils.js.map